<template>
  <div class="outlet-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card>
            <div slot="header">
              {{$t('client.basic_information')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-for="(option, i) in outlet.basic_info" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="outlet.basic_info[i].show" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.disable')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="outlet.basic_info[i].disable" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.payment_information')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-for="(option, i) in outlet.payment_info" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="outlet.payment_info[i].show" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.disable')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="outlet.payment_info[i].disable" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.time_settings_information')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-for="(option, i) in outlet.time_settings_information" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="outlet.time_settings_information[i].show" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.disable')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="outlet.time_settings_information[i].disable" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.config')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-bind:label="$t('client.upload_kml_file')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.upload_kml" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.export_tradezone')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.export_tradezone" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.draw_delivery_area')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.draw_delivery_area" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.show_address_on_list')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.show_address_on_list" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.show_menu_control')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.show_menu_control" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('store.menu_exclusion')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.show_menu_exclusion" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('store.menu_out_of_stock')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.show_menu_out_of_stock" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.show_menu_control_half_half')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.show_menu_control_half_half" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.warning_calendar')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.warning_calendar" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                  <b-form-group v-bind:label="$t('client.support_subtradezone')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.support_subtradezone" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.separate_open_hours')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.separate_open_hours" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group label="Free Text for Estimated Time" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.free_text_estimated_time" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.support_maintainance')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.support_maintainance" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.print_qr')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.print_qr" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.support_tax_fee')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.support_tax_fee" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.support_export_full_csv')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.support_export_full_csv" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.support_unique_code')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.support_unique_code" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.service_fee')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.service_fee" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-if="isUseMerchantId" v-bind:label="$t('client.show_pos_ip_address')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.show_pos_ip_address" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-if="isUseMerchantId" v-bind:label="$t('client.show_gst_number')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.show_gst_number" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-if="isUseMerchantId" v-bind:label="$t('client.show_payment_click_id')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.show_payment_click_id" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.show_reason')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.show_reason" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.show_push_to_prod')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.show_push_to_prod" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.table_control')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.table_control" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.code_validate')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.code_validate" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.restaurant')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="outlet.config.restaurant" :value="true" :uncheckedValue="false"/>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.customization')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <customization v-model="outlet.fields" :position_fields="position_fields"></customization>
              </b-col>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import cSwitch from '../../../components/Switch'
  import Customization from './Customization'

  export default {
    name: 'OutletForm',
    props: {
      value: {
        type: Object
      },
      item: {
        type: Object
      }
    },
    components: {
      Customization,
      cSwitch
    },
    data: function () {
      return {
        isJPMarket: false,
        isUseMerchantId: false,
        position_fields: [
          'outlet_code',
          'business_period',
          'payment_information',
          'time_settings_information'
        ],
        outlet: {
          basic_info: [
            {
              'name': 'Store Code',
              'type': 'store_code',
              'show': true,
              'disable': false
            },
            {
              'name': 'Aggregator Code',
              'type': 'aggregator_code',
              'show': true,
              'disable': false
            },
            {
              'name': 'Delivery Fee',
              'type': 'delivery_fee',
              'show': true,
              'disable': false
            },
            {
              'name': 'Store Name',
              'type': 'store_name',
              'show': true,
              'disable': false
            },
            {
              'name': 'AC／FSC Code',
              'type': 'acfsc_code',
              'show': true,
              'disable': false
            },
            {
              'name': 'AC／FSC Name',
              'type': 'acfsc_name',
              'show': true,
              'disable': false
            },
            {
              'name': 'Owner Name',
              'type': 'owner_name',
              'show': true,
              'disable': false
            },
            {
              'name': 'Owner Code',
              'type': 'owner_code',
              'show': true,
              'disable': false
            },
            {
              'name': 'Street Address',
              'type': 'street_address',
              'show': true,
              'disable': false
            },
            {
              'name': 'Phone',
              'type': 'phone',
              'show': true,
              'disable': false
            },
            {
              'name': 'Fax',
              'type': 'fax',
              'show': true,
              'disable': false
            },
            {
              'name': 'Store Email',
              'type': 'store_email',
              'show': true,
              'disable': false
            },
            {
              'name': 'Description',
              'type': 'description',
              'show': true,
              'disable': false
            },
            {
              'name': 'Remark',
              'type': 'remark',
              'show': true,
              'disable': false
            },
            {
              'name': 'Latitude',
              'type': 'latitude',
              'show': true,
              'disable': false
            },
            {
              'name': 'Longitude',
              'type': 'longitude',
              'show': true,
              'disable': false
            },
            {
              'name': 'Accept Online Order',
              'type': 'accept_online_order',
              'show': true,
              'disable': false
            },
            {
              'name': 'Alcohol Treatment',
              'type': 'alcohol_treatment',
              'show': true,
              'disable': false
            },
            {
              'name': 'Business Period',
              'type': 'business_period',
              'show': true,
              'disable': false
            },
            {
              'name': 'Available Dispositions',
              'type': 'available_dispositions',
              'show': true,
              'disable': false
            },
            {
              'name': 'Minimum Cart Value',
              'type': 'minimum_cart_value',
              'show': true,
              'disable': false
            },
            {
              'name': 'Estimated Time (min)',
              'type': 'estimated_time',
              'show': true,
              'disable': false
            },
            {
              'name': 'Interval Time (min)',
              'type': 'interval_time',
              'show': true,
              'disable': false
            },
            {
              'name': 'Google Search Location',
              'type': 'google_search_location',
              'show': true,
              'disable': false
            },
            {
              'name': 'Aggregators',
              'type': 'aggregators',
              'show': true,
              'disable': false
            },
            {
              'name': 'Uber Eats',
              'type': 'ubereats',
              'show': true,
              'disable': false
            },
            {
              'name': 'Timezones',
              'type': 'time_zones',
              'show': true,
              'disable': false
            }
          ],
          payment_info: [
            {
              'name': 'Credit Card Accepted',
              'type': 'credit',
              'show': true,
              'disable': false
            },
            {
              'name': 'Ponta Card Accepted',
              'type': 'ponta',
              'show': true,
              'disable': false
            },
            {
              'name': 'Gourmet Card Accepted',
              'type': 'gourmet',
              'show': true,
              'disable': false
            },
            {
              'name': 'Accept Cash',
              'type': 'cash',
              'show': true,
              'disable': false
            }
          ],
          time_settings_information: [
            {
              'name': 'Business Hours',
              'type': 'business_hours',
              'show': true,
              'disable': false
            },
            {
              'name': 'Lunch Time',
              'type': 'lunch_time',
              'show': true,
              'disable': false
            },
            {
              'name': 'Order Duration',
              'type': 'order_duration',
              'show': true,
              'disable': false
            },
            {
              'name': 'Calendar',
              'type': 'calendar',
              'show': true,
              'disable': false
            },
            {
              'name': 'Less Delivery Time Slot',
              'type': 'delivery_time',
              'show': false,
              'disable': false
            }
          ],
          fields: [],
          config: {
            upload_kml: false,
            export_tradezone: false,
            draw_delivery_area: false,
            show_address_on_list: true,
            show_menu_control: true,
            show_menu_exclusion: true,
            show_menu_out_of_stock: false,
            warning_calendar: true,
            support_subtradezone: false,
            support_maintainance: false,
            support_tax_fee: false,
            support_export_full_csv: false,
            support_unique_code: false,
            separate_open_hours: false,
            free_text_estimated_time: false,
            print_qr: false,
            show_menu_control_half_half: false,
            show_pos_ip_address: false,
            show_gst_number: false,
            show_payment_click_id: false,
            show_reason: false,
            service_fee: false,
            show_push_to_prod: false,
            table_control: false,
            code_validate: false,
            restaurant: false
          }
        },
      }
    },
    methods: {
      updateData () {
        // Update Base Info
        if (this.value != null && this.value.basic_info != null) {
          let basicInfo = {}
          for (let i in this.value.basic_info) {
            basicInfo[this.value.basic_info[i].type] = {
              show: this.value.basic_info[i].show,
              disable: this.value.basic_info[i].disable
            }
          }

          for (let i in this.outlet.basic_info) {
            if (basicInfo[this.outlet.basic_info[i].type] != null) {
              this.outlet.basic_info[i].show = basicInfo[this.outlet.basic_info[i].type].show
              this.outlet.basic_info[i].disable = basicInfo[this.outlet.basic_info[i].type].disable
            }
          }
        }

        // Update Payment Info
        if (this.value != null && this.value.payment_info != null) {
          let basicInfo = {}
          for (let i in this.value.payment_info) {
            basicInfo[this.value.payment_info[i].type] = {
              show: this.value.payment_info[i].show,
              disable: this.value.payment_info[i].disable
            }
          }

          for (let i in this.outlet.payment_info) {
            if (basicInfo[this.outlet.payment_info[i].type] != null) {
              this.outlet.payment_info[i].show = basicInfo[this.outlet.payment_info[i].type].show
              this.outlet.payment_info[i].disable = basicInfo[this.outlet.payment_info[i].type].disable
            }
          }
        }

        // Update Time Settingsn Info
        if (this.value != null && this.value.time_settings_information != null) {
          let basicInfo = {}
          for (let i in this.value.time_settings_information) {
            basicInfo[this.value.time_settings_information[i].type] = {
              show: this.value.time_settings_information[i].show,
              disable: this.value.time_settings_information[i].disable
            }
          }

          for (let i in this.outlet.time_settings_information) {
            if (basicInfo[this.outlet.time_settings_information[i].type] != null) {
              this.outlet.time_settings_information[i].show = basicInfo[this.outlet.time_settings_information[i].type].show
              this.outlet.time_settings_information[i].disable = basicInfo[this.outlet.time_settings_information[i].type].disable
            }
          }
        }

        // Update Config
        if (this.value != null && this.value.config != null) {
          for (let i in this.outlet.config) {
            if (this.value.config[i] != null) {
              this.outlet.config[i] = this.value.config[i]
            }
          }
        }

        // Update customization field
        if (this.value != null && this.value.fields != null) {
          this.outlet.fields = this.value.fields
        }
      }
    },
    created: function () {
      this.isJPMarket = this.item.uuid === this.client_uuid.jp
      const config = this.$session.get('config')
      this.isUseMerchantId = this._.get(config, 'manual_config.is_use_merchant_id', false) == true
    },
    mounted: function () {
      this.updateData()
    },
    watch: {
      outlet: {
        handler: function (newValue) {
          this.$emit('input', this.outlet)
          this.$emit('change', this.outlet)
        },
        deep: true
      },
      value: {
        handler: function (newValue) {
          this.updateData()
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/admin/client/OutletForm.vue